import { SITE } from "@/lib/brand";

export const Footer = () => (
  <footer className="no-print px-6 md:px-12 py-10 flex flex-col md:flex-row justify-between gap-3 text-sm text-[var(--muted)] border-t border-[var(--line)]">
    <p>Good brands. Great stories. Real impact. — Catalyst Crew, Mumbai</p>
    <a href={SITE} target="_blank" rel="noreferrer" data-testid="footer-site-link" className="hover:text-[var(--ink)]">www.catalystcrew.in</a>
  </footer>
);
